import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import portrait from '../../assets/mlsvd_dr.png';

const sectionCards = [
  {
    to: '/profile',
    title: 'Profile',
    description: 'Skills, expertise domains, and how I work.',
  },
  {
    to: '/projects',
    title: 'Projects',
    description: 'Personal projects, experiments, and side work.',
  },
  {
    to: '/articles',
    title: 'Articles',
    description: 'Writeups, guides, and technical deep-dives.',
  },
];

const Home = () => {
  useEffect(() => {
    document.title = 'Dmitri Malisev — Full-Stack Software Engineer';
  }, []);

  return (
    <HomeContainer>
      <Hero>
        <HeroName>Dmitri Malisev</HeroName>
        <HeroTitle>Full-Stack Software Engineer</HeroTitle>
        <HeroBio>
          Full-stack engineer with a strong backend foundation. I enjoy working on complex
          systems, shipping features end-to-end, and pushing for performance and efficiency.
          I enjoy working on legacy systems just as much as with new technologies. Equally
          fluent in building everything by hand and in orchestrating multi-agent AI workstreams
          to produce results.
        </HeroBio>
      </Hero>

      <SectionCards>
        {sectionCards.map(card => (
          <SectionCard key={card.to} to={card.to}>
            <CardTitle>{card.title}</CardTitle>
            <CardDesc>{card.description}</CardDesc>
          </SectionCard>
        ))}
      </SectionCards>

      <PortraitWrapper>
        <Portrait src={portrait} alt="Dmitri Malisev" />
      </PortraitWrapper>
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  padding: 5rem 0 4rem;
`;

const Hero = styled.div`
  max-width: 680px;
`;

const HeroName = styled.h1`
  font-size: 2.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
  letter-spacing: -0.02em;

  @media (max-width: 600px) {
    font-size: 1.75rem;
  }
`;

const HeroTitle = styled.p`
  font-family: var(--font-mono);
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--accent);
  margin: 0 0 1.75rem;
`;

const HeroBio = styled.p`
  font-size: 1.0625rem;
  line-height: 1.8;
  color: var(--text-primary);
  margin: 0 0 2.5rem;

  @media (max-width: 600px) {
    font-size: 0.9375rem;
  }
`;


const SectionCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    margin-top: 3.5rem;
  }
`;

const SectionCard = styled(Link)`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--bg-surface);
  text-decoration: none;
  transition: border-color 0.2s;

  &:hover {
    border-color: var(--accent);
  }
`;

const CardTitle = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
`;

const CardDesc = styled.span`
  font-size: 0.875rem;
  color: var(--text-muted);
  line-height: 1.6;
  flex: 1;
`;


const PortraitWrapper = styled.div`
  margin-top: 4rem;
  display: flex;
  justify-content: center;
`;

const Portrait = styled.img`
  width: 99px;
  filter: brightness(1.43) contrast(0.85);

  @media (max-width: 600px) {
    width: 90px;
  }
`;

export default Home;
